import { ventoraClamp } from 'src/components/DevicesSettings/Settings/SettingsG2/VentoraFan/ventora_fan_settings_helpers';
import { gen2Request } from './gen_2_http_reqs';
import type {
	VentoraFanBoostRequest,
	VentoraFanConfig,
	VentoraFanSetPayload,
	VentoraFanStatus,
} from 'src/types/ventora_fan';

export const getVentoraFanConfig = async (device, id = 0): Promise<VentoraFanConfig | undefined> => {
	const response = await gen2Request(device, 'Fan.GetConfig', { id });
	return response?.result as VentoraFanConfig | undefined;
};

export const setVentoraFanConfig = async (device, configPatch: Partial<VentoraFanConfig>, id = 0) => {
	return gen2Request(device, 'Fan.SetConfig', {
		id,
		config: configPatch,
	});
};

export const setVentoraFan = async (device, payload: VentoraFanSetPayload) => {
	const fanId = payload.id ?? 0;
	if (payload.mode === 'auto') {
		return gen2Request(device, 'Fan.Set', { id: fanId, mode: 'auto' });
	}
	// Wire: `{ id, mode: "manual", on, speed }` — `speed` is 1–100.
	return gen2Request(device, 'Fan.Set', {
		id: fanId,
		mode: 'manual',
		on: payload.turn,
		speed: ventoraClamp(payload.speed, 1, 100),
	});
};

export const getVentoraFanStatus = async (device, id = 0): Promise<VentoraFanStatus | undefined> => {
	const response = await gen2Request(device, 'Fan.GetStatus', { id });
	return response?.result as VentoraFanStatus | undefined;
};

export const boostVentoraFan = async (device, payload: VentoraFanBoostRequest): Promise<boolean> => {
	const response = await gen2Request(device, 'Fan.Boost', payload);
	return Boolean(response?.isok);
};

export const stopVentoraFanBoost = async (device, id = 0): Promise<boolean> => {
	const response = await gen2Request(device, 'Fan.StopBoost', { id });
	return Boolean(response?.isok);
};
